import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { logger } from "./logger";

/**
 * Mount once near the app root (inside the Router). Logs a PAGE_VIEW on
 * every route change, including how long the user spent on the previous
 * page.
 */
export const useRouteLogger = () => {
  const location = useLocation();
  const enteredAt = useRef<number>(Date.now());
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    const now = Date.now();
    const timeOnPreviousPageMs = previousPath.current
      ? now - enteredAt.current
      : undefined;

    logger.pageView({
      path: location.pathname,
      search: location.search || undefined,
      previous_path: previousPath.current || undefined,
      time_on_previous_page_ms: timeOnPreviousPageMs,
    });

    previousPath.current = location.pathname;
    enteredAt.current = now;
  }, [location.pathname, location.search]);
};
